import React, { memo } from "react";
import styled from "styled-components";
import RulesTreeReport from "views/Config/Rules/RulesTree";
import {
  PROFS,
  POLI,
  TYPE_PROFILE_SHORTCUTF_MAP,
} from "views/Config/SubscriberFlows/Tabs/constants";
import { getRulesAndConflicts } from "views/Config/Rules/utils";
import { RETURN_VIEW, LOAD_INTERVAL } from "./utils";
import useDashboardData from "./useDashboardData";
import Loading from "common/Loading";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  svg {
    .circles circle,
    path.link {
      stroke: var(--rules-tree-paths) !important;
      stroke-width: 2px !important;
    }

    text {
     fill: var(--rules-tree-paths) !important;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

const WrapperLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: var(--text-primary);
`;

// The rules of the whole configuration, which carry no option of a BQN.
const getRulesTree = () =>
  getRulesAndConflicts("flow", PROFS, POLI).then(([rulesData, conflicts]) => ({
    rules: rulesData.parsedResponse,
    rulesResp: rulesData.response,
    conflicts,
  }));

const NO_RULES = { rules: [], rulesResp: "", conflicts: undefined };

function RulesTreeView() {
  // The card has a cadence of its own: it draws no range of the dashboard,
  // so nothing else asks for its data again.
  const { data, isLoading } = useDashboardData({
    retrieve: getRulesTree,
    onError: "Error fetching rules tree view data:",
    interval: LOAD_INTERVAL,
  });

  if (isLoading) {
    return (
      <WrapperLoader>
        <Loading />
      </WrapperLoader>
    );
  }

  const { rules: rulesTree, conflicts, rulesResp } = data || NO_RULES;
  return (
    <Wrapper
      onClick={() =>
        globalNavigate("viewRulesFlow", {
          tab: 0,
          returnView: RETURN_VIEW,
        })
      }
    >
      <RulesTreeReport
        response={rulesResp}
        rules={rulesTree}
        conflicts={conflicts}
        profs={PROFS}
        poli={POLI}
        typeProfileMap={TYPE_PROFILE_SHORTCUTF_MAP}
        view="flow"
        displayInDashboard={true}
      />
    </Wrapper>
  );
}

export default memo(RulesTreeView);
